import * as React from 'react';
import { DevicePropsType } from '../../types';
import { GutmannShowcaseBrowserStyles } from './styles';

const GutmannShowcaseBrowser : React.StatelessComponent<DevicePropsType> =
  ( props : DevicePropsType ) => {
    return (
      <GutmannShowcaseBrowserStyles />
    );
  };

export default GutmannShowcaseBrowser;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Device/devices/GutmannShowcaseBrowser/GutmannShowcaseBrowser.tsx